import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-plan-change',
  templateUrl: './confirm-plan-change.component.html',
  styleUrls: ['./confirm-plan-change.component.scss']
})
export class ConfirmPlanChangeComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      currentPlan: string,
      newPlan: string,
      isUpgrade: boolean
    },
    private dialogRef: MatDialogRef<ConfirmPlanChangeComponent>
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}